import React from 'react';
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import './index.css'; // Add any global styles here
import App from './App.jsx';
import 'bootstrap/dist/css/bootstrap.min.css';
import { buildApiUrl, fetchCsrfToken, getApiOrigin, isUnsafeMethod } from './api/client';

axios.defaults.baseURL = getApiOrigin() || undefined;
axios.defaults.withCredentials = true;
axios.interceptors.request.use(async (config) => {
  const method = String(config.method || 'get').toUpperCase();
  if (config.url && !/^https?:\/\//i.test(config.url)) {
    config.url = buildApiUrl(config.url);
  }

  if (isUnsafeMethod(method)) {
    const token = await fetchCsrfToken();
    config.headers = config.headers || {};
    config.headers['X-CSRF-Token'] = token;
  }

  return config;
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
